import {connect} from "react-redux";
import FastTagTollActivitySave from "./Save";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {getActivity, activitySave, isCheckout, getPendingActivity, markAttendance, tollById, getFse, errorLogs} from "../../../service/FasttagToll/action";
import {getSenior} from "../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    types:state.FasttagToll.types,
    saveActivityResponse:state.FasttagToll.saveActivityResponse,
    isCheckoutDetails:state.FasttagToll.isCheckout,
    pendingActivity:state.FasttagToll.pendingActivity,
    attendance:state.FasttagToll.attendance,
    senior: state.Dealer.senior,
    tollView:state.FasttagToll.tollView,
    fseDetails:state.FasttagToll.fseDetails
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            getActivity,
            getSenior,
            activitySave,
            isCheckout,
            getPendingActivity,
            markAttendance,
            tollById,
            getFse,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(FastTagTollActivitySave);
